/** Admin panel design tokens — JS mirrors for inline styles. */

export const adminColors = {
  pageBg: '#f1f5f9',
  cardBg: '#ffffff',
  cardBorder: '#e2e8f0',
  primary: '#2563eb',
  primaryHover: '#1d4ed8',
  text: '#0f172a',
  muted: '#64748b',
  subtle: '#94a3b8',
  success: { text: '#15803d', bg: '#dcfce7' },
  warning: { text: '#b45309', bg: '#fef3c7' },
  error: { text: '#b91c1c', bg: '#fee2e2' },
  skeleton: '#e2e8f0',
  skeletonLight: '#f1f5f9',
}

export const adminSpacing = {
  pagePadding: '28px 32px',
  cardPadding: 20,
  gridGap: 16,
  sectionGap: 24,
}

export const adminTypography = {
  pageTitle: { fontSize: 22, fontWeight: 700, color: '#0f172a', margin: '0 0 8px', letterSpacing: '-0.02em' },
  pageSubtitle: { fontSize: 14, color: '#64748b', margin: 0, lineHeight: 1.55, maxWidth: 800 },
  sectionEyebrow: {
    fontSize: 11,
    fontWeight: 600,
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    marginBottom: 8,
  },
}

export const adminCardStyle = {
  background: adminColors.cardBg,
  border: `1px solid ${adminColors.cardBorder}`,
  borderRadius: 12,
  boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
}

export const adminPageWrap = {
  padding: adminSpacing.pagePadding,
  boxSizing: 'border-box',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  background: adminColors.pageBg,
}
